import { render } from "./RolesOverview.vue?vue&type=template&id=2c6d8af6&ts=true"
import script from "./RolesOverview.vue?vue&type=script&lang=ts"
export * from "./RolesOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__